import { render, staticRenderFns } from "./MainMatchStatsInfo.vue?vue&type=template&id=78f347ee&scoped=true&"
import script from "./MainMatchStatsInfo.vue?vue&type=script&lang=js&"
export * from "./MainMatchStatsInfo.vue?vue&type=script&lang=js&"
import style0 from "./MainMatchStatsInfo.vue?vue&type=style&index=0&id=78f347ee&prod&lang=css&"
import style1 from "./MainMatchStatsInfo.vue?vue&type=style&index=1&id=78f347ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f347ee",
  null
  
)

export default component.exports